var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 5.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M14.52 21.144H11.74l-2.086-8.088c-.1-.372-.31-.7-.619-.856a9 9 0 0 0-2.55-.856v-.311h4.482c.618 0 1.082.468 1.16 1.011l1.082 5.834 2.78-6.845h2.705zm5.719 0h-2.627l2.163-10.111h2.627zm5.562-7.31c.078-.544.541-.856 1.083-.856a4.83 4.83 0 0 1 2.55.466l.463-2.176a6.6 6.6 0 0 0-2.395-.468c-2.55 0-4.405 1.4-4.405 3.344 0 1.479 1.314 2.255 2.242 2.723 1.003.466 1.39.778 1.313 1.244 0 .7-.773 1.011-1.545 1.011-.928 0-1.856-.233-2.705-.623l-.464 2.179c.928.388 1.932.544 2.86.544 2.859.077 4.636-1.322 4.636-3.422 0-2.645-3.633-2.8-3.633-3.966m12.827 7.31-2.086-10.111h-2.24c-.465 0-.928.311-1.083.778l-3.863 9.333h2.705l.54-1.477h3.322l.31 1.477zm-3.94-7.388.772 3.81h-2.164z",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#F9F7F6",
    rx: 5.5
  })));
};
export default SvgVisa;